module.exports = __webpack_public_path__ + "static/media/phone-video.85463697.svg";